import { useMemo } from 'react';
import { useSelector } from 'react-redux';

type TAuthState = {
	isSuccess: boolean;
	isDemoUser: boolean;
	userId: string;
	email: string;
	isSafeMode: boolean;
};

import { useAuthenticateQuery } from '~services/api/auth';
import {
	getIsDemoUser,
	getIsSafeMode,
	getUserEmail,
	getUserId,
} from '~store/auth/authSlice';

export const useSession = () => {
	const { isSuccess } = useAuthenticateQuery(undefined, {});
	const email = useSelector(getUserEmail);
	const userId = useSelector(getUserId);
	const isDemoUser = useSelector(getIsDemoUser);
	const isSafeMode = useSelector(getIsSafeMode);

	const result: TAuthState = useMemo(
		() => ({
			isSuccess,
			userId: userId || '',
			email,
			isDemoUser,
			isSafeMode,
		}),
		[isSuccess, userId, email, isDemoUser, isSafeMode]
	);
	return result;
};
